/**
 * "Maybe later" for the template copy prompt. The server's onboarding struct
 * drops unknown fields, so a dismissal can't ride `template_prompt` — it lives
 * in localStorage keyed on org + prompt, which makes it self-invalidating: a
 * new prompt, or another user's org in the same browser, never matches.
 *
 * try/catch throughout — storage throws under private mode and quota.
 */

const STORAGE_KEY = "cohesive:template-prompt-dismissed";

export function isTemplatePromptDismissed(
  orgId: string,
  promptId: string,
): boolean {
  if (!orgId || !promptId) return false;
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return false;
    const parsed = JSON.parse(raw) as { org?: string; id?: string };
    return parsed?.org === orgId && parsed?.id === promptId;
  } catch {
    return false;
  }
}

export function markTemplatePromptDismissed(
  orgId: string,
  promptId: string,
): void {
  try {
    window.localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ org: orgId, id: promptId }),
    );
  } catch {
    // Storage unavailable — the prompt still hides for this view; it just
    // returns on the next home visit.
  }
}

export function clearTemplatePromptDismissal(): void {
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    // Nothing to recover: the prompt is resolved server-side either way.
  }
}
